// test420
(420 && 0);
